import { Spinner } from '@/components/Spinner/Spinner';

import styles from './styles.module.css';

export const Loader: React.FC = () => {
  return (
    <div id={styles.loader}>
      <Spinner diameter={48} />
    </div>
  );
};
